import { IDeleteChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/delete/delete_checklist_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
/**
 * DeleteChecklistMaquinaEquipUseCase
 */

export class DeleteChecklistMaquinaEquipUseCase implements IDeleteChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(idChecklistMaquinaEquip: number): Promise<void> {
    await this.repository.deleteChecklistMaquinaEquip(idChecklistMaquinaEquip);
  }
}
